import axios from "axios";
import * as dimensionTypes from "../../types/admin/dimensionsEntityTypes";

import {
  getAuthConfigAndCompanyId,
  handleApiError,
} from "../../../utils/authUtils";

export const createDimensionAction =
  (formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.CREATE_DIMENSION_REQUEST });
      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      // API endpoint: /api/admin/{companyId}/dimensions
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions`,
        formData,
        config
      );
      if (data.success === false) {
        throw new Error(data.message || "Failed to create dimension");
      }
      dispatch({
        type: dimensionTypes.CREATE_DIMENSION_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({ type: dimensionTypes.CREATE_DIMENSION_FAIL, payload: err });
      throw err;
    }
  };

export const getAllDimensionsByEntity =
  (page = 1, limit = 10, entityId) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.GET_ALL_DIMENSION_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions?page=${page}&limit=${limit}&entityId=${entityId}`,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to fetch dimensions");
      }

      dispatch({
        type: dimensionTypes.GET_ALL_DIMENSION_SUCCESS,
        payload: data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({ type: dimensionTypes.GET_ALL_DIMENSION_FAIL, payload: err });
      throw err;
    }
  };

export const setStatusActiveDimension =
  (dimensionId, statusData) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.SET_STATUS_ACTIVE_DIMENSION_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/${dimensionId}/status`,
        statusData,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to update dimension status");
      }

      dispatch({
        type: dimensionTypes.SET_STATUS_ACTIVE_DIMENSION_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.SET_STATUS_ACTIVE_DIMENSION_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getSingleDimensionAction =
  (dimensionId) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.GET_ONE_DIMENSION_REQUEST });
      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/${dimensionId}`,
        config
      );
      if (data.success === false) {
        throw new Error(data.message || "Failed to fetch dimension");
      }
      dispatch({
        type: dimensionTypes.GET_ONE_DIMENSION_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({ type: dimensionTypes.GET_ONE_DIMENSION_FAIL, payload: err });
      throw err;
    }
  };

export const updateDimensionAction =
  (dimensionId, formData) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.UPDATE_ONE_DIMENSION_REQUEST });
      const { companyId, config } = getAuthConfigAndCompanyId(getState());
      // API endpoint: /api/admin/{companyId}/dimensions/{dimensionId}
      const { data } = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/${dimensionId}`,
        formData,
        config
      );
      if (data.success === false) {
        throw new Error(data.message || "Failed to update dimension");
      }
      dispatch({
        type: dimensionTypes.UPDATE_ONE_DIMENSION_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.UPDATE_ONE_DIMENSION_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getDimensionPathHierarchy =
  (dimensionId) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.GET_DIMENSION_PATH_HEIRARCHY_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/${dimensionId}/hierarchy`,
        config
      );

      if (data.success === false) {
        throw new Error(
          data.message || "Failed to fetch dimension path hierarchy"
        );
      }

      dispatch({
        type: dimensionTypes.GET_DIMENSION_PATH_HEIRARCHY_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.GET_DIMENSION_PATH_HEIRARCHY_FAIL,
        payload: err,
      });
      throw err;
    }
  };

// Fetch overall dimension hierarchy for an Entity (across all dimensions)
export const getOverallDimensionHierarchyAction =
  (entityId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: dimensionTypes.GET_OVERALL_DIMENSION_HIERARCHY_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/hierarchy?entityId=${entityId}`,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to fetch overall hierarchy");
      }

      dispatch({
        type: dimensionTypes.GET_OVERALL_DIMENSION_HIERARCHY_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.GET_OVERALL_DIMENSION_HIERARCHY_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const updateDimensionHierarchy =
  (dimensionId, parentDimensionId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: dimensionTypes.UPDATE_DIMENSION_PATH_HEIRARCHY_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/${dimensionId}/hierarchy`,
        { parentDimensionId },
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to update dimension hierarchy");
      }

      dispatch({
        type: dimensionTypes.UPDATE_DIMENSION_PATH_HEIRARCHY_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.UPDATE_DIMENSION_PATH_HEIRARCHY_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const assignUsersToDimension =
  (dimensionId, userIds) => async (dispatch, getState) => {
    try {
      dispatch({
        type: dimensionTypes.ASSIGN_MULTIPLE_USERS_TO_DIMENSION_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/${dimensionId}/users`,
        { userIds },
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to assign users to dimension");
      }

      dispatch({
        type: dimensionTypes.ASSIGN_MULTIPLE_USERS_TO_DIMENSION_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.ASSIGN_MULTIPLE_USERS_TO_DIMENSION_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getUsersByDimension =
  (dimensionId) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.GET_ALL_USERS_TO_DIMENSION_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/${dimensionId}/users`,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to fetch users for dimension");
      }

      dispatch({
        type: dimensionTypes.GET_ALL_USERS_TO_DIMENSION_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.GET_ALL_USERS_TO_DIMENSION_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const removeUserFromDimension =
  (userId, dimensionId) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.REMOVE_USER_FROM_DIMENSION_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/users/${userId}/dimensions/${dimensionId}`,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to remove user from dimension");
      }

      dispatch({
        type: dimensionTypes.REMOVE_USER_FROM_DIMENSION_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.REMOVE_USER_FROM_DIMENSION_FAIL,
        payload: err,
      });
      throw err;
    }
  };

// Fetch hierarchy by dimension type (branch, department, trade_license)
export const getHierarchyByTypeAction =
  (entityId, dimensionType) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.GET_HIERARCHY_BY_TYPE_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/dimensions/same-type-hierarchy?entityId=${entityId}&includeSettings=true&type=${dimensionType}`,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to fetch hierarchy by type");
      }

      dispatch({
        type: dimensionTypes.GET_HIERARCHY_BY_TYPE_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.GET_HIERARCHY_BY_TYPE_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const updateEntityStatusAction =
  (entityId, statusData) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.UPDATE_ENTITY_STATUS_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.patch(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/${entityId}/status`,
        statusData,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to update entity status");
      }

      dispatch({
        type: dimensionTypes.UPDATE_ENTITY_STATUS_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.UPDATE_ENTITY_STATUS_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getFormBuilderAction = (type) => async (dispatch, getState) => {
  try {
    dispatch({ type: dimensionTypes.GET_FORM_BUILDER_REQUEST });

    const { companyId, config } = getAuthConfigAndCompanyId(getState());

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/client-dimensions/get/form-template`,
      { type: type },
      config
    );

    if (data.success === false) {
      throw new Error(data.message || "Failed to fetch form template");
    }

    dispatch({
      type: dimensionTypes.GET_FORM_BUILDER_SUCCESS,
      payload: data?.data,
    });

    return data;
  } catch (error) {
    const err = handleApiError(error);
    dispatch({
      type: dimensionTypes.GET_FORM_BUILDER_FAIL,
      payload: err,
    });
    throw err;
  }
};

export const createFormBuilderAction =
  (formPayload) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.CREATE_FORM_BUILDER_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const payloadToSend = {
        ...formPayload,
        entityId: String(formPayload.entityId).trim(),
      };

      if (formPayload?.tradeLicenseId) {
        payloadToSend.tradeLicenseId = String(formPayload.tradeLicenseId);
      }

      if (!payloadToSend.entityId || payloadToSend.entityId.trim() === "") {
        throw new Error("Entity ID is missing or invalid in payload");
      }

      const url = `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/client-dimensions/create`;

      const { data } = await axios.post(url, payloadToSend, config);

      if (data.success === false) {
        throw new Error(data.message || "Failed to create customer dimension");
      }

      dispatch({
        type: dimensionTypes.CREATE_FORM_BUILDER_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.CREATE_FORM_BUILDER_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getClientFormBuilderAction =
  (dimensionId) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.GET_CLIENT_FORM_BUILDER_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const url = `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/client-dimensions/single-client/${dimensionId}`;

      const { data } = await axios.get(url, config);

      if (data.success === false) {
        throw new Error(
          data.message || "Failed to fetch customer form builder"
        );
      }

      dispatch({
        type: dimensionTypes.GET_CLIENT_FORM_BUILDER_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.GET_CLIENT_FORM_BUILDER_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const updateClientFormBuilderAction =
  (dimensionId, formPayload) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.UPDATE_CLIENT_FORM_BUILDER_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      if (formPayload?.entityId) {
        if (
          typeof formPayload.entityId !== "string" ||
          formPayload.entityId.trim() === ""
        ) {
          throw new Error(
            "Entity ID must be a valid non-empty string if provided"
          );
        }
      }

      const payloadToSend = {
        ...formPayload,
      };

      if (payloadToSend.entityId) {
        payloadToSend.entityId = String(payloadToSend.entityId).trim();
      }

      if (payloadToSend.tradeLicenseId) {
        payloadToSend.tradeLicenseId = String(payloadToSend.tradeLicenseId);
      }

      const url = `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/client-dimensions/update/${dimensionId}`;

      const { data } = await axios.patch(url, payloadToSend, config);

      if (data.success === false) {
        throw new Error(
          data.message || "Failed to update customer form builder"
        );
      }

      dispatch({
        type: dimensionTypes.UPDATE_CLIENT_FORM_BUILDER_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: dimensionTypes.UPDATE_CLIENT_FORM_BUILDER_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const uploadDocumentCustomerDynamicFormAction =
  (file, extension) => async (dispatch, getState) => {
    try {
      dispatch({
        type: dimensionTypes.UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let formdata = new FormData();
      formdata.append("csv", file);
      formdata.append("extension", extension);
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/bulk-employee/upload`,
        formdata,
        config
      );
      dispatch({
        type: dimensionTypes.UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_SUCCESS,
        payload: data?.data,
      });
      return data;
    } catch (error) {
      let err = handleApiError(error);
      if (!err) {
        err = "Network Error";
      }
      if (!err) {
        err = "Network Error";
      }
      dispatch({
        type: dimensionTypes.UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

export const getCustomerIdAction = (entityId) => async (dispatch, getState) => {
  try {
    dispatch({ type: dimensionTypes.GET_CUSTOMER_ID_REQUEST });
    const { companyId, config } = getAuthConfigAndCompanyId(getState());
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/client-dimensions/get/customer-id`,
      config
    );
    if (data.success === false) {
      throw new Error(data.message || "Failed to fetch customer id");
    }
    dispatch({
      type: dimensionTypes.GET_CUSTOMER_ID_SUCCESS,
      payload: data.data,
    });
    return data.data;
  } catch (error) {
    const err = handleApiError(error);
    dispatch({ type: dimensionTypes.GET_CUSTOMER_ID_FAIL, payload: err });
    throw err;
  }
};

export const getAllDimensionsByEntityAction =
  (entityId) => async (dispatch, getState) => {
    try {
      dispatch({ type: dimensionTypes.GET_DIMENSION_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/entity/get-dimension/${entityId}`,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to fetch dimensions");
      }

      dispatch({
        type: dimensionTypes.GET_DIMENSION_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({ type: dimensionTypes.GET_DIMENSION_FAIL, payload: err });
      throw err;
    }
  };
